import { PackageDashboard } from "@stories/pages/Contractor/PackageDashboard/PackageDashboard";

export const ContractorPackageView = () => {
  return <PackageDashboard />;
};
